export default {url: "https://www.krisscode.fr/monstock/"}
//export default {url: "http://localhost:3005/"}